import apiClient from "../services/apiClient";
import { unwrapApiResponse } from "./unwrapApiResponse";

export async function submitJobApplication(formData) {
  const { data } = await apiClient.post(
    "/api/careers/applications",
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
  return unwrapApiResponse({ data });
}
